<template>
    <b-card bg-variant="danger" text-variant="light" border-variant="secondary" class="shadow text-center align-middle">
        <b-card-title>
            🚫 Forbidden Access 🚫
        </b-card-title>
        <b-card-text>
            You have no business accessing this application. Go somewhere else, be productive.
        </b-card-text>
		<b-button variant="danger" @click="logout">Clear Cache</b-button>
    </b-card>
</template>

<script>
import appMethod from '../mixins/appMethod'

export default {
	mixins: [
		appMethod
	]
}
</script>



// WEBPACK FOOTER //
// src/views/Forbidden.vue